import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    // Make sure MSAL is initialized before checking authentication
    if (!this.authService.isInitialized()) {
      // Delay until it's initialized
      return this.authService.init().pipe(
        switchMap(() => this.checkAuth())
      );
    }

    return this.checkAuth();
  }

  private checkAuth(): Observable<boolean | UrlTree> {
    if (this.authService.isAuthenticated()) {
      return of(true);
    }

    // Not authenticated → trigger login and cancel activation
    return this.authService.login().pipe(
      map(() => true),
      catchError(() => of(this.router.parseUrl('/login'))) // optionally redirect to a fallback route
    );
  }
}
